export default {
  fire() {
    var example = $('.languages-item').first();

    $('.add-languages-item').on('click', function () {
      var last = $('.languages-item').last();
      var language = example.clone();

      last.after(language);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/work-languages.js